import { SideNavItem, SideNavMode } from './SideNav';
import { SIDE_NAV_ITEMS } from './config';

export const fetchUserNavConfig = (
  extraNavItems: SideNavItem[],
  extraSubItems?: SideNavItem[],
) => {
  const localSideNav = localStorage.getItem('sideNavLayout');
  let navItems = [...structuredClone(SIDE_NAV_ITEMS), ...extraNavItems];
  // Append extra subItems
  navItems = navItems.map((item) => {
    if (extraSubItems) {
      for (const { key, subItems } of extraSubItems) {
        if (item.key === key) {
          item.subItems = [...(item.subItems || []), ...(subItems || [])];
        }
      }
    }
    return item;
  });
  if (!localSideNav) {
    return [...navItems];
  }
  const customNavPosition = Array.from(
    new Set(JSON.parse(localSideNav)),
  ) as string[];

  const customNav = customNavPosition
    .map((x) => navItems.find((y) => y.key === x))
    .filter(Boolean) as typeof SIDE_NAV_ITEMS;
  return customNav.concat(
    navItems.filter((x) => !customNav.find((y) => y.name === x.name)),
  );
};

export const fetchSideNavMode = () => {
  const mode = localStorage.getItem('sideNavMode');
  return (mode || 'auto') as SideNavMode;
};

export const storeSideNavMode = (mode: SideNavMode) => {
  Promise.resolve().then(() => localStorage.setItem('sideNavMode', mode));
};
